import { render, staticRenderFns } from "./pageBanner.vue?vue&type=template&id=b4fc8dae&scoped=true&"
import script from "./pageBanner.vue?vue&type=script&lang=js&"
export * from "./pageBanner.vue?vue&type=script&lang=js&"
import style0 from "./pageBanner.vue?vue&type=style&index=0&id=b4fc8dae&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4fc8dae",
  null
  
)

export default component.exports